import { constants } from "redux/constants/redux-constants";

const initialState = {
  keyword: "",
  context: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_SEARCH_KEYWORD:
      return {
        ...state,
        keyword: action.payload.keyword,
        context: action.payload.context,
      };
    default:
      return state;
  }
};

export default searchReducer;
